import { render, staticRenderFns } from "./NewSalesDocumentPage.vue?vue&type=template&id=0375e6c9&scoped=true"
import script from "./NewSalesDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewSalesDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0375e6c9",
  null
  
)

export default component.exports